import _ from 'lodash';

/**
 * @typedef ServerError
 * @prop {number} statusCode
 * @prop {string} error
 * @prop {string} message
 * @prop {object} [data] structured detail some 409s carry (e.g. `{ teamId }`,
 *   `{ blocking: [{ key, count, label }] }`)
 */

export default class RequestError extends Error {
	/**
   * @param {ServerError} serverError
   */
	constructor(serverError) {
		serverError = serverError || {};
		super(serverError.message || serverError.error);

		const shortError = _.lowerCase(serverError.error);
		this.error = shortError;
		this.code = serverError.statusCode;
		this.message = serverError.message || serverError.error;
		this.data = serverError.data && typeof serverError.data === 'object' ? serverError.data : null;
	}
}
